import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, fontSize, lineHeight } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
var Link = styled(Box).withConfig({
  componentId: "lgtdx9-0"
})(["color:", ";font-size:", ";line-height:", ";text-decoration:", ";&:hover{cursor:pointer;}&:hover,&:visited{text-decoration:", ";}"], function (_ref) {
  var contrast = _ref.contrast;
  return contrast ? color("text." + contrast) : "inherit";
}, function (_ref2) {
  var size = _ref2.size;
  return size ? fontSize(size) : "inherit";
}, function (_ref3) {
  var size = _ref3.size;
  return size ? lineHeight(size) : "inherit";
}, function (_ref4) {
  var hasUnderline = _ref4.hasUnderline;
  return hasUnderline === "none" ? "none" : hasUnderline === "always" ? "underline" : hasUnderline === "hover" ? "none" : "underline";
}, function (_ref5) {
  var hasUnderline = _ref5.hasUnderline;
  return hasUnderline === "none" ? "none" : hasUnderline === "always" ? "underline" : hasUnderline === "hover" ? "underline" : "none";
});
var Styled = {
  Link: Link
};
export { Styled };